import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=4a105658&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a105658')) {
      api.createRecord('4a105658', component.options)
    } else {
      api.reload('4a105658', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=4a105658&", function () {
      api.rerender('4a105658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Sidebar.vue"
export default component.exports